import '.d{display:flex;}.ssr-plugin'
import '.ad{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.z{align-items:center;}.ssr-plugin'
import '.a0{gap:0.5rem;}.ssr-plugin'
import '.a7{cursor:pointer;}.ssr-plugin'
import '.gw{padding:0.75rem;}.ssr-plugin'
import '.ap{border-radius:1.25rem;}.ssr-plugin'
import '.a2{border:var(--border-subtle);}.ssr-plugin'
import '.a1{background-color:var(--palette-white);}.ssr-plugin'
import '.du{transition:background-color 0.2s ease;}.ssr-plugin'
import '.fs{width:2.5rem;}.ssr-plugin'
import '.da{height:2.5rem;}.ssr-plugin'
import '.ij{color:var(--palette-blue-700);}.ssr-plugin'
import '.ik{font-size:0.9rem;}.ssr-plugin'
import '.s{font-weight:400;}.ssr-plugin'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled } from 'inlines'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { MouseEventHandler } from 'react'

export type SocialMediaButtonProps = {
  icon: IconProp
  label: string
  onClick: MouseEventHandler<HTMLButtonElement>
  isMobile?: boolean
}

export const SocialMediaButton = ({
  icon,
  label,
  onClick,
  isMobile,
}: SocialMediaButtonProps) => {
    return (
      <styled.button className="d ad e z a0 a7 gw ap a2 a1 du"
        style={{
          '&:hover': {
            backgroundColor: 'var(--palette-blue-50)',
          },
          width: isMobile ? '8rem' : '5.5rem',
          height: isMobile ? '8rem' : '5.5rem',
        }}
        onClick={onClick}
      >
        <div className="fs da d z ad ij"
          style={{
            fontSize: isMobile ? '3rem' : '2rem',
          }}
        >
          <FontAwesomeIcon icon={icon} />
        </div>
        <span className="ik ij s"
        >
          {label}
        </span>
      </styled.button>
    )
}